
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";

export class Tax extends Resource {
    public override type = 'taxes';
    
    @prop()
    @required()
    public name!: string;      
    
    @prop()
    public code!: string;     

    @prop()    
    public active: boolean = true;       
    
    @prop()    
    public percent!: number;        

    @prop()    
    public default: boolean = false;     
    
    public displayName!: string;
    
    
}